import React, { useState } from 'react';
import { Box, Button, Modal, TextField, Typography, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next'; // Importer le hook i18n

const ForgotPasswordModal = ({ open, handleClose, handleSendResetLink }) => {
  const { t } = useTranslation(); // Hook pour les traductions
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await handleSendResetLink(email);
      setSuccessMessage(t('reset_link_sent'));
      setErrorMessage('');
    } catch (error) {
      setErrorMessage(t('reset_link_error'));
      setSuccessMessage('');
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          width: '80%'
        }}
      >
        <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
          {t('reset_password')}
        </Typography>
        <Typography id="modal-description" variant="body2" color="textSecondary" sx={{ mb: 0 }} gutterBottom>
          {t('enter_email_for_reset')}
        </Typography>
        {successMessage && (
          <Alert severity="success" sx={{ mt: 2 }}>
            {successMessage}
          </Alert>
        )}
        {errorMessage && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {errorMessage}
          </Alert>
        )}
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label={t('email_address')}
            type="email"
            fullWidth
            margin="normal"
            value={email}
            sx={{ mt: 2 }}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Button type="submit" variant="contained" color="primary" fullWidth>
            {t('send')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ForgotPasswordModal;
